// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.three-line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.one-line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-multiselect .p-multiselect {
  width: 100%; /* Adjust to fit within the parent container */
}

.custom-multiselect .p-multiselect-token {
  /* Ensure tokens can wrap */
  display: inline-block;
  margin: 2px;
}

.custom-multiselect .p-multiselect-label-container {
  display: flex;
  flex-wrap: wrap; /* Allow wrapping to new lines */
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/main/email/mail-template.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AACA;EACE,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAEF;;AACA;EACE,WAAA,EAAA,8CAAA;AAEF;;AACA;EACE,2BAAA;EACA,qBAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA,EAAA,gCAAA;AAEF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
